import { Map } from "ol"
import { Circle, InitialMapOptions, MapIcon, MapViewOptions, Point, Polygon } from "./types"
import { MAP_TYPE_IDS } from "../data"

export enum FlotiMapAction {
  SET_INITIAL_MAP = 'SET_INITIAL_MAP',
  SET_INITIAL_OPTIONS = 'SET_INITIAL_OPTIONS',
  SET_MAP_POINTS = 'SET_MAP_POINTS',
  SET_POLYSHAPES = 'SET_POLYSHAPES',
  SET_CIRCLES = 'SET_CIRCLES',
  SET_TILE = 'SET_TILE',
  SET_VIEW_OPTIONS = 'SET_VIEW_OPTIONS',
  SET_MAP_ICONS = 'SET_MAP_ICONS'
}

export const setInitialMap = (data: Map) => ({
  type: FlotiMapAction.SET_INITIAL_MAP,
  data
})

export const setInitialMapOptions = (data: InitialMapOptions) => ({
  type: FlotiMapAction.SET_INITIAL_OPTIONS,
  data
})

export const setMapPoints = (data: Point[]) => ({
  type: FlotiMapAction.SET_MAP_POINTS,
  data
})

export const setMapPolyshapes = (data: Polygon[]) => ({
  type: FlotiMapAction.SET_POLYSHAPES,
  data
})

export const setMapCircles = (data: Circle) => ({
  type: FlotiMapAction.SET_CIRCLES,
  data
})

export const setMapTile = (data: MAP_TYPE_IDS) => ({
  type: FlotiMapAction.SET_TILE,
  data
})

export const setViewOptions = (data: MapViewOptions) => ({
  type: FlotiMapAction.SET_VIEW_OPTIONS,
  data
})

export const setMapIcons = (data: MapIcon[]) => ({
  type: FlotiMapAction.SET_MAP_ICONS,
  data
})
